<div class="content">
    <form #userCreateForm="ngForm" [formGroup]="userForm" data-qa="settings-users-create-form">

        <header>
            <div>
            </div>

            <div class="buttons">

                <button matButton="outlined"
                        type="button"
                        data-qa="cancel-user-button close-details-button"
                        (click)="westnetzSidenavService.closeRightnav()">
                    <mat-icon svgIcon="innogy_picto_close"></mat-icon>
                    Schließen
                </button>

                <button matButton="filled"
                        [disabled]="!userCreateForm.form.valid"
                        type="button"
                        data-qa="create-user-button"
                        (click)="saveUser()">
                    <mat-icon>save</mat-icon>
                    {{ createNew ? 'Anlegen' : 'Speichern' }}
                </button>

                @if (!createNew) {
                    <button matButton="filled"
                            type="button"
                            class="button-warn"
                            data-qa="delete-user-button"
                            (click)="deleteUser()">
                        <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
                        Löschen
                    </button>
                }

            </div>
        </header>

        <div class="detail-main">

            <fieldset>
                <legend>Schnittstellen Benutzer {{ createNew ? 'anlegen' : 'editieren' }}</legend>

                <mat-form-field>
                    <mat-label>Benutzername</mat-label>
                    <input matInput
                           maxlength="100"
                           data-qa="username"
                           formControlName="username"
                           id="username"
                           name="username"
                           required/>
                    @if (f.username.hasError('required')) {
                        <mat-error>
                            Bitte tragen Sie den Benutzername ein
                        </mat-error>
                    }
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Passwort</mat-label>
                    <input matInput
                           [type]="passwordHide ? 'password' : 'text'"
                           autocomplete="new-password"
                           data-qa="password"
                           formControlName="password"
                           id="password"
                           name="password"
                    >
                    <button mat-icon-button matSuffix
                            class="password-toggle"
                            (click)="passwordHide = !passwordHide" [attr.aria-label]="'Hide password'"
                            [attr.aria-pressed]="passwordHide">
                        <mat-icon>{{ passwordHide ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>

                    @if (f.password.hasError('required')) {
                        <mat-error>
                            Bitte tragen Sie das Password des Benutzers ein
                        </mat-error>
                    }
                </mat-form-field>

                <div fxLayout="row" fxLayoutAlign="space-between">
                    <mat-slide-toggle formControlName="enabled" color="primary" data-qa="toggle-allow-active">
                        Aktiviert
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="allowRead" color="primary" data-qa="toggle-allow-read">
                        Leserechte
                    </mat-slide-toggle>

                    <mat-slide-toggle formControlName="allowWrite" color="primary" data-qa="toggle-allow-write">
                        Schreibrechte
                    </mat-slide-toggle>
                </div>
            </fieldset>
        </div>
    </form>
</div>
